import React, { useRef, useState } from 'react';
import classNames from 'classnames';

const DEFAULT_CLASSNAME = 'c-collapsible-text';

const CollapsibleText = (props) => {
  const collapsibleContentInner = useRef();
  const collapsibleContent = useRef();
  const [isExpanded, setIsExpanded] = useState(false);
  const extendsContent =
    collapsibleContentInner.clientHeight > collapsibleContent.clientHeight;

  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };

  const componentClass = props.className ? props.className : DEFAULT_CLASSNAME;
  const buttonText = isExpanded
    ? props.buttonReadLessText
    : props.buttonReadMoreText;
  const classes = classNames({
    [`${componentClass}`]: true,
    [`${componentClass}--expanded`]: isExpanded,
    [`${componentClass}--extends-content`]: extendsContent,
    ...props.Modifiers,
  });
  if (props.hideCollapsibleText)
    return <div className={componentClass}>{props.children}</div>;

  return (
    <div className={classes}>
      {props.heading && (
        <h2 className={`${componentClass}__heading`}>{props.heading}</h2>
      )}
      <div ref={collapsibleContent} className={`${componentClass}__content`}>
        <div ref={collapsibleContentInner}>{props.children}</div>
      </div>

      <button
        aria-hidden="true"
        className={`${componentClass}__button`}
        onClick={() => handleClick()}
        type="button"
      >
        {props.buttonChildren && props.buttonChildren}

        <span className={`${componentClass}__button__inner`}>{buttonText}</span>
      </button>
    </div>
  );
};

export default CollapsibleText;
